import React, { useEffect, useState, useRef } from "react";
import Button from "../../common/Button";
import warning from "../assets/warning.png";
import info from "../assets/info.png";
import QmModuleStyle from "../styles/qm.module.css";

const CalProfitLoss = ({ popupState }) => {
  const [simPopup, setSimPopup, isOverlay, setIsOverlay, headerPopup, setHeaderPopup, isArtifacts, setIsArtifacts, plPopup, setPlPopup, ulPopup, setUlPopup, simPrgPopup, setSimPrgPopup, skipWalkThruPopups, accordionPopup, setAccordionPopup, simObj, setSimObj, formatNum, toggleSimulation, qmPopup, setQmPopup,setRelaunchPopup] = popupState;

  const cost = simObj?.laststate?.cost;
  const availableCash = simObj?.laststate?.availableCash;
  const averageFailureRate = simObj?.laststate?.averageFailureRate;
  const totalProfit = simObj?.laststate?.totalProfit;
  const starRating = simObj?.laststate?.starRating;
  const TargetSR = simObj?.laststate?.TargetSR;
  const yearlyProfitTarget = simObj?.laststate?.yearlyProfitTarget;

  const totalCostofInternalFailure =
    simObj?.laststate?.totalCostofInternalFailure;
  const totalConceptualCostOfExternalFailures =
    simObj?.laststate?.totalConceptualCostOfExternalFailures;
  const totalCostOfPreventiveInvestment =
    simObj?.laststate?.totalCostOfPreventiveInvestment;
  const totalCostOfAssesmentInvestment =
    simObj?.laststate?.totalCostOfAssesmentInvestment;
  const totalCostOfRedHerringInvestment =
    simObj?.laststate?.totalCostOfRedHerringInvestment;
  const currentTargetCompletion =
    simObj?.laststate?.currentTargetCompletion;
  const expectedTargetCompletionByDate =
    simObj?.laststate?.expectedTargetCompletionByDate;

  const progressbar = {
    valuemin: 0,
    valuemax: simObj?.laststate?.yearlyProfitTarget,
    valuenow: function () {
      return Math.round((simObj?.laststate?.totalProfit / this.valuemax) * 100);
    },
  };
  const [isToggledtotalCost, setIsToggledtotalCost] = useState(false); //total cost of quality
  const [isToggledProfloss, setIsToggledProfloss] = useState(false); //Profit & loss
  const [weeksRemaining, setWeeksRemaining] = useState(0);
  //const [isFluidPopup, setIsFluidPopup] = useState(false);
  //const [isFluidPopup1, setIsFluidPopup1] = useState(false);
  //const [isFluidPopup2, setIsFluidPopup2] = useState(false);
  const [shouldRenderSpan, setShouldRenderSpan] = useState(false);
  const popupRef = useRef(null);
  const buttonRef = useRef(null);
  const profLossRef = useRef(null);
  const profLossBtnRef = useRef(null);
  const noOfRatings = [1, 2, 3, 4, 5];
  let costPerUnit = 0;
  simObj.actions?.map(function (action) {
    costPerUnit = action.options.costPerUnit;
  });

  const handleToggle = (event) => {
    if(event === undefined){
      return;
    }
    setIsToggledtotalCost((prev) => {
    const next = !prev;
    // Focus popup when it opens
    if (!prev) {
      setTimeout(() => popupRef.current?.focus(), 150);
    }
    return next;
    });
  };
  
  const handleKeyDown = (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      
      // Toggle the popup
      setIsToggledtotalCost((prev) => {
        const next = !prev;
        // Focus popup when it opens
        if (!prev) {
          setTimeout(() => popupRef.current?.focus(), 150);
        }
        // If the popup is closing, set focus back to the info icon
        if (prev) {
          setTimeout(() => buttonRef.current?.focus(), 100);
        }
        return next;
      });
      
      setIsToggledProfloss(false); // Optionally close the profit-loss popup if it's open
    } else if (event.key === "Escape") {
      // Close popup when pressing Escape
      setIsToggledtotalCost(false);
      setTimeout(() => buttonRef.current?.focus(), 100); // Return focus to the info icon
    } else if (event.key === "Tab") {
      setIsToggledtotalCost(false);
    }
  };
//   window.$(document).on("click", function(e){
//     if(!window.$(e.target).closest('#detailsTotalCost').length > 0){
//       setIsToggledtotalCost(false);
//     }
//  })
 const handleToggleProfit = (event) => {
  if(event === undefined){
    return;
  }
  setIsToggledProfloss((prev) => {
    const next = !prev;
    if(!prev){
      setTimeout(() => profLossRef.current?.focus(), 150);
    }
    return next;
  });
};

const handleKeyDownProfit = (event) => {
  // Toggle the button when Enter or Space is pressed
  if (event.key === 'Enter' || event.key === ' ') { 
      event.preventDefault();
      // Toggle the popup
      setIsToggledProfloss((prev) => {
        const next = !prev;
        // Focus popup when it opens
        if (!prev) {
          setTimeout(() => profLossRef.current?.focus(), 150);
        }
        // If the popup is closing, set focus back to the info icon
        if (prev) {
          setTimeout(() => profLossBtnRef.current?.focus(), 100);
        }
        return next;
      });
      setIsToggledtotalCost(false);
    // handleToggleProfit(event);
  } else if (event.key === "Escape") {
      setIsToggledProfloss(false);
      setTimeout(() => profLossBtnRef.current?.focus(), 100);
  } else if (event.key === "Tab") {
      setIsToggledProfloss(false);
  }
};
// window.$(document).on("click", function(e){
//   if(!window.$(e.target).closest('#Profloss').length > 0){
//     setIsToggledProfloss(false);
//   }
// })

  const calculateWeeksRemaining = () => {
    if (simObj) {
      const newWeeksRemaining = Math.ceil((simObj?.laststate?.daysleft) / 7);
      if (weeksRemaining !== newWeeksRemaining) {
        setWeeksRemaining(newWeeksRemaining);
        setShouldRenderSpan(true);
      } else {
        setShouldRenderSpan(false);
      }
      //console.log(newWeeksRemaining,weeksRemaining)
    }
  };
  const formatStarNum = (number) => {
    let formattedNumber = number.toString();
    formattedNumber = formattedNumber.includes('.') ? formattedNumber.replace(/\.?0*$/, '') : formattedNumber;
    return formattedNumber;
  }
  /* commented for keyboard navigation infoIcon
    const clickHandler = (e) => {
    let image = document.querySelector("#details img");
    let image1 = document.querySelector("#details1 img");
    let _Pgoal = document.querySelector("#progressed-goal");
    if (e.target != image) {
      setIsFluidPopup(false);
    }
    if (e.target != image1) {
      setIsFluidPopup1(false);
    }
  }*/
  useEffect(() => {
    calculateWeeksRemaining();
  }, [simObj?.currentstep]);

  /* commented for keyboard Navigation infoIcon
  useEffect(() => {
    const detailsIcon = document.querySelector("#details");
    const detailsIcon1 = document.querySelector("#details1");
    const progressGoal = document.querySelector("#progressed-goal");
    detailsIcon.addEventListener("focus", () => {
      setIsFluidPopup(true)
      // detailsIcon.style.setProperty("outline", "none", "important");
    });
    detailsIcon.addEventListener("blur", () => {
      setIsFluidPopup(false)
    });
    detailsIcon1.addEventListener("focus", () => {
      setIsFluidPopup1(true)
      // detailsIcon1.style.setProperty("outline", "none", "important");
    });
    detailsIcon1.addEventListener("blur", () => {
      setIsFluidPopup1(false)
    });

    if (window.innerWidth > 991) {
      document.querySelector("#details img").addEventListener("mouseenter", () => setIsFluidPopup(true));
      document.querySelector("#details img").addEventListener("mouseleave", () => setIsFluidPopup(false));
      document.querySelector('#details1 img').addEventListener("mouseenter", () => setIsFluidPopup1(true));
      document.querySelector('#details1 img').addEventListener("mouseleave", () => setIsFluidPopup1(false));
    }
    // if (document.querySelector("#details") != null || document.querySelector("#progressed-goal") != null) {
    //   document.querySelector("#details").setAttribute("tabindex", "0");
    //   document.querySelector("#progressed-goal").setAttribute("tabindex", "0");
    // }
  }, []);
  useEffect(() => {
    setTimeout(() => {
      if (isFluidPopup || isFluidPopup1  || isFluidPopup2) {
        document.addEventListener("click", clickHandler);
      }
    }, 1000);
    if (!isFluidPopup|| !isFluidPopup1 || !isFluidPopup2) {
      document.removeEventListener("click", clickHandler);
    }
  }, [isFluidPopup,isFluidPopup1, isFluidPopup2]) */

  useEffect(() => {
    const handleClickOutside  = (e) => {
      const button = buttonRef.current;
      const popup = popupRef.current;
      if (
        popup &&
        !popup.contains(e.target) &&
        button &&
        !button.contains(e.target)
      ) {
        setIsToggledtotalCost(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  useEffect(() => {
    const handleClickProfLossPopup = (e) => {
      const btn = profLossBtnRef.current;
      const profPopup = profLossRef.current;
      if(profPopup && !profPopup.contains(e.target) && btn && !btn.contains(e.target)){
        setIsToggledProfloss(false);
      }
    };

    document.addEventListener("click", handleClickProfLossPopup);
    return () => document.removeEventListener("click", handleClickProfLossPopup);
  },[]);

  return (
    // <div className={`${QmModuleStyle["profit-loss-container"]}`}>
    <div className={`${QmModuleStyle["profit-loss"]}`}>
      {
        (shouldRenderSpan && (simObj.status != 'COMPLETED') && toggleSimulation) &&
        (<span aria-live="assertive" role="alert" className={`sr-only pl-hiddenspan`}>
          {Math.ceil((simObj?.laststate?.daysleft) / 7)} weeks remaining <br />
          Total Cost of Quality: ${formatNum(Math.round(cost != undefined ? cost : 0))} <br />
          Available Cash: ${formatNum(Math.round(availableCash != undefined ? availableCash : 0))} <br />
          Average Failure Rate: {averageFailureRate != undefined ? averageFailureRate : 0}% <br />
          Profit & Loss: ${formatNum(Math.round(totalProfit != undefined ? totalProfit : 0))} <br />
          Profit & Loss Progressbar: {Math.round(((totalProfit < 0 ? Math.round(Math.abs(totalProfit)) : totalProfit) / yearlyProfitTarget) * 100)}% <br />
          Rating: {starRating != undefined ? formatStarNum(starRating) : 0} <span className={`${QmModuleStyle["sr-only"]}`}> star rating</span> <br />
          Goal: {TargetSR != undefined ? TargetSR : 0} <span className={`${QmModuleStyle["sr-only"]}`}> star rating</span> <br />
        </span>)
      }
      <div className={`${QmModuleStyle["tot-costs"]}`}>
        <h3 className={`${QmModuleStyle["pl-header"]}`}>
          Total Cost of Quality
        </h3>
        <p className={`tc-content ${QmModuleStyle.bld} ${QmModuleStyle["tc-content"]} `}>
          ${formatNum(
            Math.round(cost != undefined ? cost : 0)
          )}
        </p>
        <a id={`${QmModuleStyle.detailsTotalCost}`} ref={buttonRef} href="javascript:void(0)" role="button" aria-label="Info about Total Cost of Quality" 
            onClick={handleToggle}
            onKeyDown={handleKeyDown}
            // onMouseEnter={()=> {
            //   if(window.innerWidth > 991) {
            //     setIsToggledtotalCost(true);
            //   }
            // }}
            // onMouseLeave={()=> {
            //   if(window.innerWidth > 991) {
            //     setIsToggledtotalCost(false);
            //   }
            // }}
            ><img src={info} alt="" aria-hidden="true" role="presentation"/></a>
        <div ref={popupRef} tabIndex={-1} role="dialog" aria-live="polite" className={`ui fluid popup top left transition ${QmModuleStyle.ui} ${QmModuleStyle.fluid} ${QmModuleStyle.popup}`} style={{ display: isToggledtotalCost ? "block" : "none" }} onKeyDown={handleKeyDown}>
          <ul className={`${QmModuleStyle["popup-info"]}`} role="list">
            <li role="listitem">
              <span>Total Cost of Internal Failures</span>
              <span>
                <strong>
                  ${formatNum(Math.round(totalCostofInternalFailure != undefined ? totalCostofInternalFailure : 0))}
                </strong>
              </span>
            </li>
            <li role="listitem">
              <span>Total Cost of External Failures</span>
              <span>
                <strong>
                  ${formatNum(Math.round(totalConceptualCostOfExternalFailures != undefined ? totalConceptualCostOfExternalFailures : 0))}
                </strong>
              </span>
            </li>
            <li role="listitem">
              <span>Total Cost of Preventive Investments</span>
              <span>
                <strong>
                  ${formatNum(Math.round(totalCostOfPreventiveInvestment != undefined ? totalCostOfPreventiveInvestment : 0))}
                </strong>
              </span>
            </li>
            <li role="listitem">
              <span>Total Cost of Appraisal Investments</span>
              <span>
                <strong>
                  ${formatNum(Math.round(totalCostOfAssesmentInvestment != undefined ? totalCostOfAssesmentInvestment : 0))}
                </strong>
              </span>
            </li>
            <li role="listitem">
              <span>Total Cost of Other Investments</span>
              <span>
                <strong>
                  ${formatNum(Math.round(totalCostOfRedHerringInvestment != undefined ? totalCostOfRedHerringInvestment : 0))}
                </strong>
              </span>
            </li>
          </ul>
        </div>

      </div>
      <div className={`cash`}>
        <h3 className={`${QmModuleStyle["pl-header"]}`}>Available Cash</h3>
        <p className={`us-content tc-content ${QmModuleStyle.bld}`}>
          ${formatNum(Math.round(availableCash != undefined ? availableCash : 0))}
        </p>
      </div>
      <div className={`${QmModuleStyle['tot-revenue']}  ${(qmPopup?.kpiBox) ? `show ${QmModuleStyle['show']}` : ''}`} >
        <h3 className={`${QmModuleStyle["pl-header"]}`}>
          Average Failure Rate
        </h3>
        <p className={`tr-content tc-content ${QmModuleStyle.bld}`}>
          {averageFailureRate != undefined ? averageFailureRate : 0}%
        </p>
      </div>
      <div className={`${QmModuleStyle["pl-progress"]} ${(qmPopup?.kpiBox) ? `show ${QmModuleStyle['show']}` : ''} `} id="progressed-goal" >
        
        <div className={`${plPopup ? `show ${QmModuleStyle["show"]}` : ""}`}>
          <div>
            <h3 className={`${QmModuleStyle["pl-header"]}`}>Profit & Loss</h3>
            <a id={`${QmModuleStyle.Profloss}`} ref={profLossBtnRef} href="javascript:void(0)" role="button" aria-label="Info about Profit and Loss" onClick={handleToggleProfit}
            onKeyDown={handleKeyDownProfit}
            // onMouseEnter={()=> {
            //   if(window.innerWidth > 991) {
            //     setIsToggledProfloss(true);
            //   }
            // }}
            // onMouseLeave={()=> {
            //   if(window.innerWidth > 991) {
            //     setIsToggledProfloss(false);
            //   }
            // }}
            ><img src={info} alt="" width={15} aria-hidden="true" role="presentation"/></a>
            <div ref={profLossRef} tabIndex={-1} role="dialog" aria-live="polite" className={`ui fluid popup bottom center transition ${QmModuleStyle.ui} ${QmModuleStyle.fluid} ${QmModuleStyle.popup}`} style={{ display: isToggledProfloss ? "block" : "none" }} onKeyDown={handleKeyDownProfit}>
              <ul className={`${QmModuleStyle["popup-goal"]}`} role="list">
                <li role="listitem">
                  <span>Current completion of yearly target</span>
                  <span>
                    <strong>
                      {(currentTargetCompletion != undefined ? (Math.floor(currentTargetCompletion * 10) / 10).toFixed(1) : 0)}%
                    </strong>
                  </span>
                </li>
                <li role="listitem">
                  <span>Expected completion by this date</span>
                  <span>
                    <strong>
                      {(expectedTargetCompletionByDate != undefined ? (Math.floor(expectedTargetCompletionByDate * 10) / 10).toFixed(1) : 0)}%
                    </strong>
                  </span>
                </li>
              </ul>
            </div>
          </div>
          <p className={`${QmModuleStyle['pl-amt']}`} >${formatNum(Math.round(totalProfit != undefined ? totalProfit : 0))}</p>
          <div className={`${QmModuleStyle.progress}`} role="progressbar"
            aria-valuenow={progressbar.valuenow()}
            aria-valuemin={progressbar.valuemin}
            aria-valuemax={progressbar.valuemax}
            aria-valuetext={`${progressbar.valuenow()}%`}>
            <div className={`background`} id={`${QmModuleStyle.profitLoss}`}>
              <div className={`${QmModuleStyle['progress-fg']}`} style={{ "width": (totalProfit == undefined) ? "0%" : (((totalProfit < 0 ? Math.round(Math.abs(totalProfit)) : totalProfit) / yearlyProfitTarget) * 100) + '%', "background": (totalProfit < 0) ? '#B90000' : '#156815' }}></div>
            </div>
          </div>
          <p className={`${QmModuleStyle['goal-amt']}`}>Goal: ${formatNum(Math.round(yearlyProfitTarget != undefined ? yearlyProfitTarget : 0))}</p>
        </div>
      </div>
      <div className={`${QmModuleStyle["rating"]} ${(qmPopup?.kpiBox) ? `show ${QmModuleStyle['show']}` : ''} `}>
        <div>
          <h3 className={`${QmModuleStyle["pl-header"]}`}>Rating</h3>
          <div className={`${QmModuleStyle["rating-block"]} ${QmModuleStyle["star-rating"]}`} >
            <p><strong>{starRating != undefined ? formatStarNum(starRating) : 0} <span className={`${QmModuleStyle["sr-only"]}`}>star rating</span></strong></p>
            <div>
              <ul className={`${QmModuleStyle["rating-list"]}`} aria-hidden="true">
                {noOfRatings.map((number, index) =>
                  number <= starRating ? (
                    <li key={number}>
                      <span className={`fa fa-star checked ${QmModuleStyle["fa"]} ${QmModuleStyle["fa-star"]}`} />
                    </li>
                  ) : Number(starRating) === starRating &&
                    starRating % 1 !== 0 &&
                    number <= Math.round(starRating) ? (
                    <li key={number}>
                      <span className={`fa fa-star-half-o ${QmModuleStyle["fa"]} ${QmModuleStyle["fa-star-half-o"]}`} />
                    </li>
                  ) : (
                    <li key={number}>
                      <span className={`fa fa-star-o ${QmModuleStyle["fa"]} ${QmModuleStyle["fa-star-o"]}`} />
                    </li>
                  )
                )}
              </ul>
            </div>
          </div>
          {/* <p className={`${QmModuleStyle['rating-count']}`}><span className={`fa fa-star checked ${QmModuleStyle['fa']} ${QmModuleStyle['fa-star']}`} aria-label='star'></span>{starRating != undefined ? starRating : 0}</p> */}
          <div className={`${QmModuleStyle["rating-block"]}`}>
            <p className={`${QmModuleStyle["goal-amt"]}`}>
              Goal: {TargetSR != undefined ? TargetSR : 0} <span className={`${QmModuleStyle["sr-only"]}`}>star rating</span>
            </p>
            <div>
              <ul className={`${QmModuleStyle["rating-list"]}`} aria-hidden="true">
                {noOfRatings.map((number, index) =>
                  number <= TargetSR ? (
                    <li key={number}>
                      <span className={`fa fa-star checked ${QmModuleStyle["fa"]} ${QmModuleStyle["fa-star"]}`} />
                    </li>
                  ) : Number(TargetSR) === TargetSR &&
                    TargetSR % 1 !== 0 &&
                    number <= Math.round(TargetSR) ? (
                    <li key={number}>
                      <span className={`fa fa-star-half-o ${QmModuleStyle["fa"]} ${QmModuleStyle["fa-star-half-o"]}`} />
                    </li>
                  ) : (
                    <li key={number}>
                      <span className={`fa fa-star-o ${QmModuleStyle["fa"]} ${QmModuleStyle["fa-star-o"]}`} />
                    </li>
                  )
                )}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
   
    // </div>
  );
};

export default CalProfitLoss;
